export default function setup() {
    const initChoices = (selector, placeholder) => {
        const el = document.querySelector(selector);
        if (!el) return null;

        return new Choices(el, {
            placeholder: true,
            placeholderValue: placeholder,
            shouldSort: false,
            searchEnabled: false,
            itemSelectText: '',
            loadingText: 'Loading...',
            noResultsText: 'No results found',
            noChoicesText: 'No options available',
            classNames: {
                containerInner: 'choices__inner',
                input: 'choices__input',
                listDropdown: 'choices__list--dropdown'
            }
        });
    };

    const initChoicesMultiple = (selector, placeholder) => {
        const el = document.querySelector(selector);
        if (!el) return null;

        return new Choices(el, {
            placeholder: true,
            placeholderValue: placeholder,
            shouldSort: false,
            searchEnabled: false,
            itemSelectText: '',
            loadingText: 'Loading...',
            noResultsText: 'No results found',
            noChoicesText: 'No options available',
            removeItemButton: true,
            classNames: {
                containerInner: 'choices__inner',
                input: 'choices__input',
                listDropdown: 'choices__list--dropdown'
            }
        });
    };

    const choices = {
        fromYear: initChoices('.js-choice-from-year', 'Select From Year'),
        toYear: initChoices('.js-choice-to-year', 'Select To Year'),
        makes: initChoices('.js-choice-makes', 'Select Make'),
        models: initChoices('.js-choice-models', 'Select Model'),
        fromPrice: initChoices('.js-choice-from-price', 'Select From Price'),
        toPrice: initChoices('.js-choice-to-price', 'Select To Price'),
        mileage: initChoices('.js-choice-mileage', 'Select Distance'),
        states: initChoicesMultiple('.js-choice-states','Location State')
    };

    

    const handleMakeChange = () => {
        const makesSelect = document.querySelector('.js-choice-makes');
        if (!makesSelect || !choices.models) return;

        let controller = null;

        makesSelect.addEventListener('change', async (e) => {
            const makeId = e.target.value;
            const modelsContainer = document.querySelector('.js-choice-models').closest('.choices');

            // Clear previous state
            choices.models.removeActiveItems();
            choices.models.clearStore();
            modelsContainer.classList.add('choices--loading');

            // Abort previous request
            if (controller) controller.abort();

            if (!makeId) {
                // Reset to placeholder if no make selected
                choices.models.clearChoices();
                choices.models.setChoices([{
                    value: '',
                    label: 'Select Model',
                    placeholder: true
                }], 'value', 'label', true);
                modelsContainer.classList.remove('choices--loading');
                return;
            }

            try {
                controller = new AbortController();
                const response = await fetch(`/boatssearch/getmodels?itemTypeId=${makeId}`, {
                    signal: controller.signal,
                    method: 'GET'
                });

                const data = await response.json();
                modelsContainer.classList.remove('choices--loading');

                // Format model options
                const modelOptions = data.map(model => ({
                    value: model.systemFields.contentItemGUID,
                    label: model.model,
                    selected: false,
                    disabled: false
                }));

                // Clear existing choices first
                choices.models.clearChoices();

                if (modelOptions.length > 0) {
                    // Add placeholder and model options
                    choices.models.setChoices([
                        { value: '', label: 'Select Model', placeholder: true }
                    ].concat(modelOptions), 'value', 'label', true);
                } else {
                    choices.models.setChoices([{
                        value: '',
                        label: 'No models available',
                        disabled: true
                    }], 'value', 'label', true);
                }
            }
            catch (error) {
                if (error.name !== 'AbortError') {
                    modelsContainer.classList.remove('choices--loading');
                    choices.models.setChoices([{
                        value: '',
                        label: 'Error loading models',
                        disabled: true
                    }], 'value', 'label', true);
                }
            }
        });
    };
    // Handle search form submission with SEO-friendly URL generation
    const handleSearchSubmit = (event) => {
        event.preventDefault();
        
        const form = event.target;
        const formData = new FormData(form);
        
        // Build SEO-friendly URL
        let pathUrl = '/used-ski-boats/';
        const pathSegments = [];
        
        // Handle zip code
        const zipCode = formData.get('ZipCode');
        if (zipCode && zipCode !== '') {
            pathSegments.push(`zip-${zipCode}`);
            
            // Only add radius if there's a zip code
            const distance = formData.get('Distance');
            if (distance && distance !== '' && distance !== 'null') {
                pathSegments.push(`radius-${distance}`);
            }
        }
        
        // Handle makes and models (single select)
        const selectedMake = formData.get('ItemType');
        const selectedModel = formData.get('Model');
        
        if (selectedMake && selectedMake !== '') {
            const makeModelPairs = [];
            
            // Get selected make name
            const makeSelect = document.getElementById('ItemTypes');
            const selectedMakeName = makeSelect.options[makeSelect.selectedIndex].textContent;
            
            // Get selected model name
            let selectedModelName = '';
            if (selectedModel && selectedModel !== '') {
                const modelSelect = document.getElementById('Model');
                selectedModelName = modelSelect.options[modelSelect.selectedIndex].textContent;
            }
            
            console.log('Selected make:', selectedMakeName);
            console.log('Selected model:', selectedModelName);
            
            // Add make and model combination
            const cleanMake = selectedMakeName.replace(/\s+Boats?$/i, '').toLowerCase();
            
            if (selectedModelName && selectedModelName !== '') {
                // Add make:model combination
                const cleanModel = selectedModelName.toLowerCase().trim();
                makeModelPairs.push(`${cleanMake}:${cleanModel}`);
            } else {
                // Add just the make
                makeModelPairs.push(cleanMake);
            }
            
            if (makeModelPairs.length > 0) {
                const encodedPairs = makeModelPairs.map(pair => {
                    if (pair.includes(':')) {
                        const [make, model] = pair.split(':');
                        return `${make}:${encodeURIComponent(model)}`;
                    }
                    return pair;
                });
                pathSegments.push(`makemodel-${encodedPairs.join('&')}`);
            }
        }
        
        // Handle year range
        const fromYear = formData.get('FromYear');
        const toYear = formData.get('ToYear');
        if (fromYear && fromYear !== '' && fromYear !== 'null') {
            const yearRange = toYear && toYear !== '' && toYear !== 'null' 
                ? `year-${fromYear}-${toYear}` 
                : `year-${fromYear}`;
            pathSegments.push(yearRange);
        }
        
        // Handle price range
        const fromPrice = formData.get('FromPrice');
        const toPrice = formData.get('ToPrice');
        if (fromPrice && fromPrice !== '' && fromPrice !== 'null') {
            const priceRange = toPrice && toPrice !== '' && toPrice !== 'null' 
                ? `price-${fromPrice}-${toPrice}` 
                : `price-${fromPrice}`;
            pathSegments.push(priceRange);
        }
        
        // Build final URL
        if (pathSegments.length > 0) {
            pathUrl += pathSegments.join('/') + '/';
        }
        
        console.log('Generated URL:', pathUrl);
        
        // Redirect to the SEO-friendly URL
        window.location.href = pathUrl;
        
        return false; // Prevent default form submission
    };

    // Attach form submission handler
    const searchForm = document.querySelector('form[onsubmit="return handleSearchSubmit(event)"]');
    if (searchForm) {
        searchForm.addEventListener('submit', handleSearchSubmit);
    }
    
    handleMakeChange();
}